<template>
  <div class="modal modal-overlay" @click.self="$emit('close')">
    <div class="maincont" id="Data_download">
      <div id="download">
        <div id="download_set">

          <h2>空調機電力データ</h2>

          <dl class="display_date">

            <select class="download-type" v-model="reportType" style="border: 2px solid rgb(92, 161, 214);border-radius: 2px;">
              <option value="1">日別</option>
              <option value="2">月別</option>
              <option value="3">年別</option>
            </select>

            <br><br><br>

            <dt>取得開始</dt>
            <dd>
              <datepicker
                :minimum-view="'day'"
                format="yyyy年MM月dd月"
                :language="ja"
                :disabled-dates="this.dayInfo.disabled.start"
                style="border: 2px solid rgb(92, 161, 214);border-radius: 2px;"
                v-model="getStartDay"
                v-if="reportType == 1"
              ></datepicker>

              <datepicker
                :minimum-view="'month'"
                format="yyyy年MM月"
                :language="ja"
                :disabled-dates="this.monthInfo.disabled.start"
                style="border: 2px solid rgb(92, 161, 214);border-radius: 2px;"
                v-model="getStartMonth"
                v-if="reportType == 2"
              ></datepicker>

              <datepicker
                :minimum-view="'year'"
                format="yyyy年"
                :language="ja"
                :disabled-dates="this.yearInfo.disabled.start"
                style="border: 2px solid rgb(92, 161, 214);border-radius: 2px;"
                v-model="getStartYear"
                v-if="reportType == 3"
              ></datepicker>
            </dd>

            <span>～</span>

            <dt>取得終了</dt>
            <dd>
              <datepicker
                :minimum-view="'day'"
                format="yyyy年MM月dd日"
                :language="ja"
                :disabled-dates="this.dayInfo.disabled.end"
                style="border: 2px solid rgb(92, 161, 214);border-radius: 2px;"
                v-model="getEndDay"
                v-if="reportType == 1"
              ></datepicker>

              <datepicker
                :minimum-view="'month'"
                format="yyyy年MM月"
                :language="ja"
                :disabled-dates="this.monthInfo.disabled.end"
                style="border: 2px solid rgb(92, 161, 214);border-radius: 2px;"
                v-model="getEndMonth"
                v-if="reportType == 2"
              ></datepicker>

              <datepicker
                :minimum-view="'year'"
                format="yyyy年"
                :language="ja"
                :disabled-dates="this.yearInfo.disabled.end"
                style="border: 2px solid rgb(92, 161, 214);border-radius: 2px;"
                v-model="getEndYear"
                v-if="reportType == 3"
              ></datepicker>
            </dd>
          </dl>

          <div id="submit_area">
            <input type="button" id="submit" class="submit" value="帳票ダウンロード" @click="onDownload">
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import Datepicker from "vuejs-datepicker";
import {ja} from 'vuejs-datepicker/dist/locale'

moment.tz.setDefault("Asia/Tokyo");
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */

export default {
  name: "download-dialog",
  props: ["account"],
  components: {
    Datepicker
  },
  data: function() {
    return {
      ja: ja,
      reportType: 1,
      dayInfo: {
        disabled: {
          start: { from: null, to: null },
          end  : { from: null, to: null }
        },
        param: {
          start: null,
          end  : null
        }
      },
      monthInfo: {
        disabled: {
          start: { from: null, to: null },
          end  : { from: null, to: null }
        },
        param: {
          start: null,
          end  : null
        }
      },
      yearInfo: {
        disabled: {
          start: { from: null, to: null },
          end  : { from: null, to: null }
        },
        param: {
          start: null,
          end  : null
        }
      }
    };
  },

  watch: {
    reportType: function(newValue, oldValue) {
      this.reportType = newValue;
    }
  },

  computed: {
    getStartDay: {
      get: function() {
        return moment.utc(this.dayInfo.param.start, "YYYY/MM/DD").toISOString();
      },
      set: function(newValue) {
        this.dayInfo.param.start = moment(newValue);
        this.setDayRange();
      }
    },

    getEndDay: {
      get: function() {
        return moment.utc(this.dayInfo.param.end, "YYYY/MM/DD").toISOString();
      },
      set: function(newValue) {
        this.dayInfo.param.end = moment(newValue);
        this.setDayRange();
      }
    },

    getStartMonth: {
      get: function() {
        return moment.utc(this.monthInfo.param.start, "YYYY/MM/DD").toISOString();
      },
      set: function(newValue) {
        this.monthInfo.param.start = moment(newValue);
        this.setMonthRange();
      }
    },

    getEndMonth: {
      get: function() {
        return moment.utc(this.monthInfo.param.end, "YYYY/MM/DD").toISOString();
      },
      set: function(newValue) {
        this.monthInfo.param.end = moment(newValue);
        this.setMonthRange();
      }
    },

    getStartYear: {
      get: function() {
        return moment.utc(this.yearInfo.param.start, "YYYY/MM/DD").toISOString();
      },
      set: function(newValue) {
        this.yearInfo.param.start = moment(newValue);
        this.setYearRange();
      }
    },

    getEndYear: {
      get: function() {
        return moment.utc(this.yearInfo.param.end, "YYYY/MM/DD").toISOString();
      },
      set: function(newValue) {
        this.yearInfo.param.end = moment(newValue);
        this.setYearRange();
      }
    }
  },

  mounted: function() {
    this.dayInfo.param.start   = moment();
    this.dayInfo.param.end     = moment();
    this.monthInfo.param.start = moment();
    this.monthInfo.param.end   = moment();
    if (moment().month() < 3) {
      this.yearInfo.param.start  = moment().add(-1, "year");
      this.yearInfo.param.end    = moment().add(-1, "year");
    } else {
      this.yearInfo.param.start  = moment();
      this.yearInfo.param.end    = moment();
    }

    this.setDayRange();
    this.setMonthRange();
    this.setYearRange();
  },

  methods: {
    setDayRange: function() {
      this.dayInfo.disabled.start = {
        to  : new Date(moment().add(-1, "year").year(), moment().add(-1, "year").month(), moment().add(-1, "year").date()),
        from: new Date(this.dayInfo.param.end.year(), this.dayInfo.param.end.month(), this.dayInfo.param.end.date() + 1)
      }
      this.dayInfo.disabled.end = {
        to  : new Date(this.dayInfo.param.start.year(), this.dayInfo.param.start.month(), this.dayInfo.param.start.date()),
        from: new Date(moment().year(), moment().month(), moment().date() + 1)
      }
    },

    setMonthRange: function() {
      this.monthInfo.disabled.start = {
        to  : new Date(moment().add(-3, "year").year(), moment().add(-3, "year").month(), 1),
        from: new Date(this.monthInfo.param.end.year(), this.monthInfo.param.end.month(), 1)
      }
      this.monthInfo.disabled.end = {
        to  : new Date(this.monthInfo.param.start.year(), this.monthInfo.param.start.month(), 1),
        from: new Date(moment().year(), moment().month(), 1)
      }
    },

    setYearRange: function() {
      if (moment().month() < 3) {
        this.yearInfo.disabled.start = {
          to  : new Date(moment().add(-5, "year").year(), 0, 1),
          from: new Date(this.yearInfo.param.end.year(), 0, 1)
        }
        this.yearInfo.disabled.end = {
          to  : new Date(this.yearInfo.param.start.year(), 11, 1),
          from: new Date(moment().year() - 1, 11, 1)
        }
      } else {
        this.yearInfo.disabled.start = {
          to  : new Date(moment().add(-4, "year").year(), 0, 1),
          from: new Date(this.yearInfo.param.end.year(), 0, 1)
        }
        this.yearInfo.disabled.end = {
          to  : new Date(this.yearInfo.param.start.year(), 11, 1),
          from: new Date(moment().year(), 11, 1)
        }
      }
    },

    onDownload: function() {
      let api = null;
      let param = null;
      if (this.reportType == 1) {
        api   = "air_conditioner_monitoring_day_download";
        param = { start_date: this.dayInfo.param.start.format("YYYY/MM/DD"), end_date: this.dayInfo.param.end.format("YYYY/MM/DD") };
      } else if (this.reportType == 2) {
        api   = "air_conditioner_monitoring_month_download";
        param = { start_date: this.monthInfo.param.start.format("YYYY/MM/01"), end_date: this.monthInfo.param.end.format("YYYY/MM/01") };
      } else {
        api   = "air_conditioner_monitoring_year_download";
        param = { start_date: this.yearInfo.param.start.format("YYYY/04/01"), end_date: this.yearInfo.param.end.add(1, "year").format("YYYY/03/01") };
      }

      this.$axios
        .post(`/srv/api/${api}/${this.account}`, param, {
          withCredentials: true,
          responseType: "blob",
          exposedHeaders: ["Content-Disposition"]
        })
        .then(response => {
          console.log(response);
          console.log(response.headers["content-disposition"]);
          let fileName = "";
          const contentDisposition = response.headers["content-disposition"];
          let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          let matches = filenameRegex.exec(contentDisposition);
          if (matches != null && matches[1]) {
            fileName = matches[1].replace(/['"]/g, "");
          }
          console.log(fileName);

          if (response.headers["content-type"].indexOf("application/json") != -1) {
            alert("ダウンロードできませんでした");
            return;
          }
          const dl = document.getElementById("downloadLink");
          if (dl != undefined) dl.parentNode.removeChild(dl);

          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("id", "downloadLink");
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          this.$emit("close");
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<style>
.modal.modal-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}

.modal .modal-window {
  background: #fff;
  border-radius: 4px;
  overflow: hidden;
}

.modal .modal-content {
  padding: 10px 20px;
}

.modal .modal-footer {
  background: #ccc;
  padding: 10px;
  text-align: right;
}

.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.4s;

  /* .modal-window {
   transition: opacity 0.4s, transform 0.4s;
 } */
}

.modal-leave-active {
  transition: opacity 0.6s ease 0.4s;
}

.modal-enter,
.modal-leave-to {
  opacity: 0;

  /* .modal-window {
    opacity: 0;
    transform: translateY(-20px);
  } */
}

.download-type {
  width: 100px;
}

</style>